<template>
    <section class="quiz">
        <div class="quiz__ring--mobile"><img src="img/quiz/ringMobile.png" alt="ring"></div>
        <div class="quiz__circle--mobile"><img src="img/quiz/circleMobile.png" alt="circle"></div>
        <div class="quiz__ring"><img src="img/quiz/ring.png" alt="ring"></div>
        <div class="quiz__circle"><img src="img/quiz/circle.png" alt="circle"></div>

        <div class="container quiz__container step success">
            <div class="quiz__box quiz__box--img"><img src="img/quiz/money.png" alt="money"></div>
            <div class="quiz__box success-quiz__box">
                <form class="quiz__form" action="#">
                    <div class="quiz__box-wrap success-quiz__box-wrap">
                        <div class="success__text">
                            <h6 class="quiz__box-title success__title">Спасибо за заявку!</h6>
                            <p class='quiz__box-subtitle'>В ближайшее время наш оператор свяжется с вами для расчета стоимости</p>
                        </div>
                        <div class="success__img"><img src="img/quiz/shape.png" alt="shape"></div>
                    </div>
                    <div class="step__button-wrap success__button-wrap">
                        <button @click.prevent="goHome" class="step__button success__button">OK</button>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>

export default {
name: "ThanksQuiz",
    methods:{
        goHome(){
            window.location.href='/'
        }
    }

}
</script>

<style scoped>

</style>
